import { useQuery } from '@apollo/client';

import type { UseXingUserFeaturesFeatureFragment } from './use-xing-user-features-feature.fragment.gql-types';
import { UseXingUserFeaturesDocument } from './use-xing-user-features-query.gql-types';

/**
 * @deprecated Use `useFeature`/`useFeatures` instead: `import { useFeature, useFeatures } from '@xing-com/hub';` and e.g. `const isPremium = useFeature('isPremium', false);`. See also: https://brewery.preview.xing.io/hub#features
 */
export function useXingUserFeatures(): UseXingUserFeaturesFeatureFragment {
  const { data } = useQuery(UseXingUserFeaturesDocument, {
    fetchPolicy: 'cache-first',
  });

  return data?.viewer?.features ?? {};
}
